import axios from 'axios'

// axios.defaults.withCredentials = true

export default {
  ge: axios.create({
    baseURL: process.env.VUE_APP_BASE_URL,
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json'
    }
  }),
  sg: axios.create({
    baseURL: process.env.VUE_APP_BASE_URL.replace('https://capico', 'https://sg.capico').replace('https://titan', 'https://sgtitan'),
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json'
    }
  }),
  get: axios.create({
    baseURL: process.env.VUE_APP_BASE_URL.replace('https://capico', 'https://get.capico').replace('https://titan', 'https://gettitan'),
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json'
    }
  }),
  hk: axios.create({
    baseURL: process.env.VUE_APP_BASE_URL.replace('https://', 'https://hk.'),
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}
//
// export default axios.create({
//   baseURL: process.env.VUE_APP_BASE_URL,
//   withCredentials: true,
//   headers: {
//     'Content-Type': 'application/json'
//   }
// })
